module.exports = __webpack_public_path__ + "assets/images/JPY500.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JPY500.png
// module id = 1410
// module chunks = 1